import { render, staticRenderFns } from "./formList.vue?vue&type=template&id=78edd078&scoped=true"
import script from "./formList.vue?vue&type=script&lang=js"
export * from "./formList.vue?vue&type=script&lang=js"
import style0 from "./formList.vue?vue&type=style&index=0&id=78edd078&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78edd078",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('78edd078')) {
      api.createRecord('78edd078', component.options)
    } else {
      api.reload('78edd078', component.options)
    }
    module.hot.accept("./formList.vue?vue&type=template&id=78edd078&scoped=true", function () {
      api.rerender('78edd078', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/develop/module/components/formList.vue"
export default component.exports